import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import { Routes, Route } from 'react-router-dom'
import { useState } from 'react'
import { ToastContainer } from 'react-toastify'
import { AuthProvider } from '@providers/context/componenets/AuthContext'
import ChangePassword from '@modules/auth/passChange/components/ChangePassword'
import Sidebar from '@layouts/sidebar/components/Sidebar'
import BlockingErrorModal from '@layouts/blockingError/components/BlockingErrorModal'
import UserGroup from '@modules/userGroups/componenets/UserGroupsTable'
import Logout from '@modules/auth/logout/componenets/Logout'
import Login from '@modules/auth/login/components/Login'
import GuestGuard from '@router/guards/GuestGuard'
import AuthGuard from '@router/guards/AuthGuard'
import UsersTable from '@modules/users/componenets/UsersTable'
import Person from '@modules/staff/person/Person'
import EducationalDegree from '@modules/staff/educationalDegree/components/EducationalDegree'
import Schools from '@modules/staff/schools/componenets/Schools'
import MajorContracts from '@modules/staff/majorContracts/components/MajorContracts'
import AdditionalAgreement from '@modules/staff/additionalAgreement/components/AdditionalAgreement'
import Region from '@modules/additionalSettings/regions/componenets/Regions'
import WorkingCapacity from '@modules/staff/person/workingCapacity/componenets/WorkingCapacity'
import SystemDocuments from '@modules/staff/person/systemDocuments/components/SystemDocuments'
import BanksTable from '@modules/payments/banks/components/BanksTable'
import PensionHistory from '@modules/staff/person/pensionHistory/componenets/PensionHistory'
import LevelsOfStructuralGroups from '@modules/organizationalStructure/levelOfStructure/components/LevelsOfStructuralGroups'
import Positions from '@modules/organizationalStructure/positions/components/Positions'
import Companies from '@modules/organizationalStructure/companies/componenets/Companies'
import CompanyCenters from '@modules/organizationalStructure/companies/componenets/CompanyCenters'
import StructuralGroups from '@modules/organizationalStructure/structuralGroups/components/StructuralGroups'
import JobDescriptions from '@modules/organizationalStructure/jobDescriptions/components/JobDescriptions'
import Currency from '@modules/payments/currency/componenets/Currency'
import BankAccounts from '@modules/payments/companyBankAcc/componenets/BankAccounts'
import Identificators from '@modules/additionalSettings/nomenclatures/components/Identificators'
import IdentificatorValues from '@modules/additionalSettings/nomenclatures/components/IdentificatorValues'
import AdditionalAccess from '@modules/additionalSettings/additionalAccess/components/AdditionalAccess'
import ProfileActivation from '@modules/additionalSettings/profileActivation/components/ProfileActivation'
import Locations from '@modules/organizationalStructure/locations/components/Locations'
import Home from '@modules/auth/login/components/Home'
import Signees from '@modules/organizationalStructure/signees/components/Signees'
import NomenclaturesOz from '@modules/organizationalStructure/nomenclatures/components/NomenclaturesOz'
import StructuralGroupMoving from '@modules/organizationalStructure/structuralGroups/components/StructuralGroupMoving'
import StructuralGroupRights from '@modules/organizationalStructure/structuralGroups/components/StructuralGroupRights'
import Calendar from '@modules/additionalSettings/calendar/components/Calendar'
import NomenclatureTranslations from '@modules/additionalSettings/nomenclatureTranslations/components/NomenclatureTranslations'
import BasisForTermination from '@modules/staff/basisForTermination/components/BasisForTermination'
import NoticePeriod from '@modules/staff/noticePeriod/components/NoticePeriod'
import ReasonForLeaving from '@modules/staff/reasonLeaving/componenents/ReasonForLeaving'
import ExcessByEmployer from '@modules/staff/excessPayments/byEmployer/components/ExcessByEmployer'
import ExcessByEmployee from '@modules/staff/excessPayments/byEmployee/components/ExcessByEmployee'
import Register from '@modules/staff/register/Register'
import ElectronicWork from '@modules/staff/register/nra/componenets/ElectronicWork'
import NraReport from '@modules/staff/register/nra/componenets/NraReport'
import ElectronicWorkReportTable from '@modules/staff/register/nra/componenets/ElectronicWorkReportTable'
import InvestmentServices from '@modules/staff/person/forms/personDocuments/components/InvestmentServices'
import Compensations from '@modules/staff/person/forms/employeePaidLeave/components/Compensations'
import TemplateDocuments from '@modules/additionalSettings/templateDocuments/componenets/TemplateDocuments'
import PersonalFiles from '@/modules/staff/register/personalFiles/components/PersonalFiles'
import HrInformation from '@/modules/staff/register/hrInformation/components/HrInformation'
import StaffMovements from '@/modules/staff/register/staffMovement/components/StaffMovements'
import Art123 from '@/modules/staff/art123/components/Art123'
import PaidLeaveApp from '@/modules/staff/paidLeaveApp/components/PaidLeaveApp'
import LengthOfService from '@/modules/compensations/lengthOfService/components/LengthOfService'

function App() {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false)

  return (
    <AuthProvider>
      <ToastContainer />
      <BlockingErrorModal />
      <div className="app">
        <Sidebar
          isExpanded={isSidebarExpanded}
          onToggle={setIsSidebarExpanded}
        />
        <main className={`main-content ${!isSidebarExpanded ? 'sidebar-collapsed' : ''}`}>
          <Routes>
            <Route element={<GuestGuard />}>
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />
            </Route>
            <Route element={<AuthGuard />}>
              <Route path="/home" element={<Home />} />
              {/* Administrator */}
              <Route path="/administrator/users" element={<UsersTable />} />
              <Route path="/administrator/user-groups" element={<UserGroup />} />
              {/* Staff */}
              <Route path='/change-password' element={<ChangePassword />} />
              <Route path="/personnel/settings/education-qualification" element={<EducationalDegree />} />
              <Route path="/personnel/settings/educational-institutions" element={<Schools />} />
              <Route path="/staff/hr-register" element={<Person />} />
              <Route path="/working-capacity/:id" element={<WorkingCapacity />} />
              <Route path="/system-documents/:id" element={<SystemDocuments />} />
              <Route path="/payments/settings/banks" element={<BanksTable />} />
              <Route path="/pension-history/:id" element={<PensionHistory />} />
              <Route path="/personnel/settings/labor-office-nra/employment-contracts" element={<MajorContracts />} />
              <Route path="/personnel/settings/labor-office-nra/additional-agreements" element={<AdditionalAgreement />} />
              <Route path="/personnel/settings/labor-office-nra/termination/basis" element={<BasisForTermination />} />
              <Route path="/personnel/settings/labor-office-nra/termination/notice-periods" element={<NoticePeriod />} />
              <Route path="/personnel/settings/labor-office-nra/termination/resignation-reasons" element={<ReasonForLeaving />} />
              <Route path="/personnel/settings/labor-office-nra/termination/compensation/employer" element={<ExcessByEmployer />} />
              <Route path="/personnel/settings/labor-office-nra/termination/compensation/employee" element={<ExcessByEmployee />} />
              <Route path="/personnel/employment-contracts/register" element={<Register />} />
              <Route path="/personnel/employment-contracts/electronic-work" element={<ElectronicWork />} />
              <Route path="/personnel/employment-contracts/nra-reports" element={<NraReport />} />
              <Route path="/personnel/employment-contracts/nra-reports-table" element={<ElectronicWorkReportTable />} />
              <Route path="/investment-services" element={<InvestmentServices />} />
              <Route path="/personnel/settings/labor-office-nra/termination/compensation" element={<Compensations />} />
              <Route path="/personnel/employment-contracts/reports/personal-files" element={<PersonalFiles />} />
              <Route path="/personnel/employment-contracts/reports/hr-information" element={<HrInformation />} />
              <Route path="/personnel/employment-contracts/reports/hr-movement" element={<StaffMovements />} />
              <Route path="/personnel/self-service/leave-requests" element={<PaidLeaveApp />} />
              {/* Organizational Structure */}
              <Route path="/structure-levels" element={<LevelsOfStructuralGroups />} />
              <Route path="/organizational-structure/positions" element={<Positions />} />
              <Route path="/organizational-structure/companies" element={<Companies />} />
              <Route path="/organizational-structure/company-centers/:companyId" element={<CompanyCenters />} />
              <Route path="/structure-and-positions" element={<StructuralGroups />} />
              <Route path="/job-descriptions" element={<JobDescriptions />} />
              <Route path="/locations" element={<Locations />} />
              <Route path="/document-signers" element={<Signees />} />
              <Route path="/nomenclatures-oz" element={<NomenclaturesOz />} />
              <Route path="/structural-group-moving" element={<StructuralGroupMoving />} />
              <Route path="/structural-group-rights" element={<StructuralGroupRights />} />
              {/* Payments */}
              <Route path="/payments/settings/currencies" element={<Currency />} />
              <Route path="/payments/settings/company-bank-accounts" element={<BankAccounts />} />
              {/* Compensations */}
              <Route path="/employment-compensations/settings/regulatory-documents/work-experience-percentages" element={<LengthOfService />} />
              <Route path="/employment-compensations/settings/regulatory-documents/art-123" element={<Art123 />} />
              {/* Additional Additional Settings */}
              <Route path="/additional-settings/regions" element={<Region />} />
              <Route path="/additional-settings/nomenclatures" element={<Identificators />} />
              <Route path="/additional-settings/nomenclatures/values" element={<IdentificatorValues />} />
              <Route path="/additional-settings/additional-work-rights" element={<AdditionalAccess />} />
              <Route path="/additional-settings/profile-activation" element={<ProfileActivation />} />
              <Route path="/additional-settings/calendar-holidays" element={<Calendar />} />
              <Route path="/additional-settings/nomenclature-translations" element={<NomenclatureTranslations />} />
              <Route path="/additional-settings/template-settings" element={<TemplateDocuments />} />
              {/* Signout */}
              <Route path="/signout" element={<Logout />} />
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </main>
      </div>
    </AuthProvider>
  )
}

export default App
